import { render, staticRenderFns } from "./DialogConfirmAction.vue?vue&type=template&id=497c7f38&scoped=true"
import script from "./DialogConfirmAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogConfirmAction.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DialogConfirmAction.vue?vue&type=style&index=0&id=497c7f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c7f38",
  null
  
)

export default component.exports